import React from 'react'
import { Layout } from 'antd'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import classNames from 'classnames'
import TopBar from 'components/layout/TopBar'
import Menu from 'components/layout/Menu'
import AnnouncementBanner from 'components/layout/AnnouncementBanner'

const mapStateToProps = ({ settings }) => ({
  isContentMaxWidth: settings.isContentMaxWidth,
  isAppMaxWidth: settings.isAppMaxWidth,
  isGrayBackground: settings.isGrayBackground,
  isSquaredBorders: settings.isSquaredBorders,
  isCardShadow: settings.isCardShadow,
  isBorderless: settings.isBorderless,
  isTopbarFixed: settings.isTopbarFixed,
  isGrayTopbar: settings.isGrayTopbar,
  isMenuCollapsed: settings.isMenuCollapsed,
  leftMenuWidth: settings.leftMenuWidth,
})

@withRouter
@connect(mapStateToProps)
class MainLayout extends React.PureComponent {
  state = {
    bannerHeight: 0,
  }

  handleBannerHeightChange = bannerHeight => {
    if (bannerHeight !== this.state.bannerHeight) {
      this.setState({ bannerHeight })
    }
  }

  render() {
    const {
      children,
      isContentMaxWidth,
      isAppMaxWidth,
      isGrayBackground,
      isSquaredBorders,
      isCardShadow,
      isBorderless,
      isTopbarFixed,
      isGrayTopbar,
      isMenuCollapsed,
      leftMenuWidth,
    } = this.props
    const sidebarWidth = isMenuCollapsed ? 56 : leftMenuWidth
    return (
      <div className={classNames({ cui__layout__grayBackground: isGrayBackground })}>
        {!window.location.toString().includes('/reportlink/') && (
          <AnnouncementBanner
            sidebarWidth={sidebarWidth}
            onHeightChange={this.handleBannerHeightChange}
            ctaTo="https://bloo.io/blog/engineering-against-drift"
          />
        )}
        <Layout
          className={classNames({
            cui__layout__contentMaxWidth: isContentMaxWidth,
            cui__layout__appMaxWidth: isAppMaxWidth,
            cui__layout__grayBackground: isGrayBackground,
            cui__layout__squaredBorders: isSquaredBorders,
            cui__layout__cardsShadow: isCardShadow,
            cui__layout__borderless: isBorderless,
          })}
        >
          <Menu />
          <Layout id="width">
            <Layout.Header
            // className={classNames('cui__layout__header', {
            //   cui__layout__fixedHeader: isTopbarFixed,
            //   cui__layout__headerGray: isGrayTopbar,
            // })}
            >
              <TopBar />
            </Layout.Header>

            <Layout.Content
              className={'contentBG scroll-barStyle'}
              style={{
                height:
                  !window.location.toString().includes('/report') &&
                  document.body.clientHeight - 44 - this.state.bannerHeight,
              }}
            >
              <div
                className="cui__utils__content"
                style={{
                  padding: '0px 11px 4px',
                }}
              >
                {children}
              </div>
            </Layout.Content>
          </Layout>
        </Layout>
      </div>
    )
  }
}

export default MainLayout
